import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, TextField, Button, Typography,
  Alert, CircularProgress, Container
} from '@mui/material';

let API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002/api';
if (window.location.protocol === 'https:' && API_BASE_URL.startsWith('http://')) {
  API_BASE_URL = API_BASE_URL.replace('http://', 'https://');
}

const ParentLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // If already logged in, redirect to dashboard by notifying parent
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        if (userData.role === 'parent') {
          onLogin(userData);
        }
      } catch (e) {
        console.error('Error parsing user data in login redirect check:', e);
      }
    }
  }, [onLogin]);

  const urlParams = new URLSearchParams(window.location.search);
  const fcmFromUrl = urlParams.get('fcm_token') || '';
  const platformFromUrl = urlParams.get('platform') || '';
  const effectiveFcmToken = fcmFromUrl || localStorage.getItem('fcm_token') || 'ABC';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Encrypt password to base64
      const encryptedPassword = btoa(credentials.password);
      console.log('Login attempt:', credentials.email, encryptedPassword);

      const urlParams = new URLSearchParams(window.location.search);
      const fcmFromUrl = urlParams.get('fcm_token');
      const fcmFromStorage = localStorage.getItem('fcm_token');
      const fcmToken = fcmFromUrl || fcmFromStorage || 'ABC';

      if (fcmFromUrl) {
        localStorage.setItem('fcm_token', fcmFromUrl);
      }
      
      const requestBody = {
        email: credentials.email,
        password: encryptedPassword,
        fcm_token: fcmToken
      };
      console.log('Request body:', requestBody);
      
      const response = await fetch(`${API_BASE_URL}/auth/parent/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      console.log('Response status:', response.status);
      
      const responseText = await response.text();
      console.log('Raw response:', responseText);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('JSON parse error:', parseError);
        setError('Invalid response from server');
        return;
      }
      
      console.log('Parsed response data:', data);

      if (response.ok) {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        console.log('Login successful, token stored as authToken');
        onLogin(data.user);
      } else {
        console.log('Login failed:', data.message);
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Network error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, sm: 3 },
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4 }}>
            <Box textAlign="center" mb={3}>
              <Box
                component="img"
                src="/logo.png"
                alt="Parent Login"
                sx={{ height: 60, mb: 2 }}
              />
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Parent Login
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Track My Child - Secure Access
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={credentials.email}
                onChange={(e) =>
                  setCredentials({ ...credentials, email: e.target.value })
                }
                margin="normal"
                required
                disabled={loading}
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials({ ...credentials, password: e.target.value })
                }
                margin="normal"
                required
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                sx={{ mt: 3, mb: 2 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Login'}
              </Button>
            </form>
            
            <Box textAlign="center" mt={2}>
              <Button
                variant="text"
                size="small"
                onClick={() => window.location.href = '/'}
              >
                ← Back to Login Selection
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default ParentLogin;